export default {
  'menu.产品分析.打点验证中心': '打点验证中心',
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.resource': '资源管理',
  'menu.resource.server': '节点管理',
  'menu.resource.ip-pool': 'IP 池管理',
  'menu.resource.machine': '机器管理',
  'menu.resource.deploy-template': '部署模板',
  'menu.resource.server-template': '节点模板',
  'menu.resource.ssh-key': '密钥管理',
  'menu.system': '系统管理',
  'menu.system.monitor': '系统状态监控',
  'menu.system.queue-monitor': '任务队列监控',
  'menu.system.version': '版本管理',
  'menu.system.app-client': '应用管理',
  'menu.dns': '域名管理',
  'menu.dev': 'Dev',
  'menu.dev.nodes': '节点控制',
  'menu.dev.agents': 'Agent 控制',
  'menu.dev.services': '服务注册',
  'menu.asset': 'Asset',
  'menu.asset.provider-accounts': '供应商账号',
  'menu.asset.machines': '机器',
  'menu.asset.ips': 'IP',
  'menu.asset.ssh-keys': 'SSH 密钥',
  'menu.asset.scripts': '脚本',
  'menu.asset.operations': '操作记录',
  'menu.资源资产': '资源资产',
  'menu.资源资产.供应商账号': '供应商账号',
  'menu.资源资产.机器': '机器',
  'menu.资源资产.IP': 'IP',
  'menu.资源资产.SSH 密钥': 'SSH 密钥',
  'menu.资源资产.脚本': '脚本',
  'menu.资源资产.操作记录': '操作记录',
  'menu.iam': 'IAM',
  'menu.iam.users': '用户管理',
  'menu.iam.roles': '角色管理',
  'menu.iam.permissions': '权限目录',
  'menu.iam.menus': '菜单管理',
  'menu.iam.clients': 'Client 管理',
  'menu.iam.audit-logs': '审计日志',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.resource.asn': 'ASN 管理',
  'menu.resource.provider': '供应商管理',
  'menu.common-report': '常用报表',
  'menu.common-report.project': '项目汇总',
  'menu.report': '数据报表',
  'menu.report.performance': '用户节点报告',
  'menu.report.traffic': '流量报表',
  'menu.report.user-report-realtime': '用户上报实时数据',
  'menu.report.perf-distribution': '性能分布分析',
  'menu.report.failed-nodes': '失败节点报表',
  'menu.report.performance-diagnosis': '性能诊断',
  'menu.report.user-report-admin': '用户上报',
  'menu.report.node-report-admin': '节点上报',
  'menu.report.node-summary-report': '节点汇总',
  'menu.report.user-summary-report': '用户汇总',
  'menu.report.project': '项目汇总',
  'menu.report.project-hourly': '项目小时汇总',
  'menu.report.app-connection-report': '应用连接报表',
  'menu.ad-spend': '投放消耗',
  'menu.business.invite-gift-card': '邀请礼品卡',
  'menu.business.invite-gift-card-logs': '发放日志',
  'menu.business': '业务管理',
  'menu.business.user-manage': '用户管理',
  'menu.business.plan': '套餐管理',
  'menu.business.order': '订单管理',
  'menu.business.external-order-receipt': '回执订单',
  'menu.business.ticket': '工单管理',
  'menu.ad': '广告变现',
  'menu.traffic-platform': '代理流量',
  'menu.traffic-platform.dashboard': '代理流量看板',
  'menu.产品分析': '产品分析',
  'menu.产品分析.全局项目总览': '全局项目总览',
  'menu.产品分析.单项目诊断': '单项目诊断',
  'menu.产品分析.漏斗分析': '漏斗分析',
  'menu.产品分析.漏斗分析.多项目漏斗总览': '多项目漏斗总览',
  'menu.产品分析.漏斗分析.单项目漏斗分析': '单项目漏斗分析',
  'menu.产品分析.漏斗分析.步骤转化诊断': '步骤转化诊断',
  'menu.产品分析.漏斗分析.分群对比分析': '分群对比分析',
  'menu.产品分析.漏斗分析.路径与流失分析': '路径与流失分析',
  'menu.产品分析.漏斗分析.事件证据明细': '事件证据明细',
  'menu.产品分析.漏斗分析.问题与效果验证': '问题与效果验证',
  'menu.产品分析.漏斗分析.漏斗口径快照': '漏斗口径快照',
  'menu.产品分析.AdMob 分析': 'AdMob 分析',
  'menu.产品分析.Firebase 分析': 'Firebase 分析',
  'menu.产品分析.数据对账': '数据对账',
  'menu.产品分析.打点验收中心': '打点验收中心',
  'menu.产品分析.规范与项目配置': '规范与项目配置',
  'menu.产品分析.数据任务与告警': '数据任务与告警',

  'menu.project': '项目管理',
  'menu.project-card': '项目管理Card',
  'menu.project.list': '项目列表',
  'menu.project.developer-panel': '开发面板',
  'menu.project.product-panel': '产品面板',
  'menu.project.app-mappings': '应用归因映射',
  'menu.project.detail': '项目详情',
  'menu.detail': '详情',
  'menu.firebase-analytics': 'Firebase',
  'menu.firebase-analytics.dashboard': 'Dashboard',
  'menu.firebase-analytics.node-status': '节点状态',
  'menu.firebase-analytics.app-open': 'App 打开分析',
  'menu.firebase-analytics.vpn-session': 'VPN 连接分析',
  'menu.firebase-analytics.vpn-probe': '节点测速分析',
  'menu.firebase-analytics.api-error': 'API 错误分析',
  'menu.firebase-analytics.events': '事件明细查询',
  'menu.nodes': 'Nodes',
  'menu.nodes.overview': 'Overview',
  'menu.nodes.list': 'Nodes',
  'menu.nodes.agents': 'Agents',
  'menu.asset.regions': '区域',
  'menu.asset.zones': '可用区',
  'menu.asset.instance-types': '实例规格',
  'menu.asset.images': '镜像',
  'menu.asset.security-groups': '安全组',
  'menu.asset.subnets': '子网',
  'menu.asset.tags': '标签',
  'menu.资源资产.区域': '区域',
  'menu.资源资产.可用区': '可用区',
  'menu.资源资产.实例规格': '实例规格',
  'menu.资源资产.镜像': '镜像',
  'menu.资源资产.安全组': '安全组',
  'menu.资源资产.子网': '子网',
  'menu.资源资产.标签': '标签',
  'menu.投放管理': '投放管理',
  'menu.投放管理.投放首页': '投放首页',
  'menu.投放管理.报表': '报表',
  'menu.投放管理.报表.Overall日报': 'Overall日报',
  'menu.投放管理.报表.Overall小时报表': 'Overall小时报表',
  'menu.投放管理.报表.Event日报': 'Event日报',
  'menu.投放管理.更新日志': '更新日志',
  'menu.投放管理.广告投放': '广告投放',
  'menu.投放管理.广告投放.广告汇总': '广告汇总',
  'menu.投放管理.广告投放.广告账户': '广告账户',
  'menu.投放管理.广告投放.Campaign': 'Campaign',
  'menu.投放管理.广告投放.Ad Set': 'Ad Set',
  'menu.投放管理.广告投放.Ad': 'Ad',
  'menu.投放管理.广告投放.Creative': 'Creative',
  'menu.投放管理.广告投放.创建广告': '创建广告',
  'menu.投放管理.自动化': '自动化',
  'menu.投放管理.自动化.规则管理': '规则管理',
  'menu.投放管理.自动化.执行历史': '执行历史',
  'menu.投放管理.组织管理': '组织管理',
  'menu.投放管理.组织管理.代理商管理': '代理商管理',
  'menu.投放管理.组织管理.团队管理': '团队管理',
  'menu.投放管理.组织管理.项目组管理': '项目组管理',
  'menu.投放管理.组织管理.账户管理': '账户管理',
  'menu.投放管理.Token 管理': 'Token 管理',
  'menu.投放管理.BM 管理': 'BM 管理',
  'menu.投放管理.平台账户': '平台账户',
  'menu.投放管理.系统设置': '系统设置',
  'menu.投放管理.系统设置.用户管理': '用户管理',
  'menu.投放管理.系统设置.角色管理': '角色管理',
  'menu.投放管理.系统设置.权限管理': '权限管理',
  'menu.投放管理.系统设置.字典管理': '字典管理',
  'menu.投放管理.系统设置.租户管理': '租户管理',
  'menu.投放管理.系统设置.操作日志': '操作日志',
  'menu.投放管理.系统设置.更新日志管理': '更新日志管理',
};
